import React, { useEffect } from 'react'
import styled from '@emotion/styled'
import { Checkbox, Col, Form, Input, Row } from 'antd'

const StyledDomainForm = styled.div({})

const DomainForm = ({ domain, form, formKeys }) => {
  const { getFieldDecorator } = form
  const uremediate = form.getFieldValue(formKeys.UREMEDIATE)
  const ssl = form.getFieldValue(formKeys.SSL)

  useEffect(() => {
    if (!uremediate && ssl) {
      form.setFieldsValue({
        [formKeys.SSL]: false
      })
    }
  }, [uremediate, ssl])

  return (
    <StyledDomainForm>
      <Form layout="vertical" hideRequiredMark>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item>
              {getFieldDecorator(formKeys.DOMAIN, {
                initialValue: domain?.domain,
                rules: [{ required: true, whitespace: true, message: 'Please enter DOMAIN or WILDCARD' }]
              })(<Input placeholder="DOMAIN or WILDCARD" />)}
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item>
              {form.getFieldDecorator(formKeys.UREMEDIATE, {
                initialValue: domain?.uremediate,
                valuePropName: 'checked'
              })(<Checkbox>uRemediate</Checkbox>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item>
              {form.getFieldDecorator(formKeys.SSL, {
                initialValue: domain?.ssl,
                valuePropName: 'checked'
              })(<Checkbox disabled={!form.getFieldValue(formKeys.UREMEDIATE)}>SSL</Checkbox>)}
            </Form.Item>
          </Col>
        </Row>
        
        {form.getFieldValue(formKeys.UREMEDIATE) && 
         <Row gutter={16}>
          <Col span={24}>
            <Form.Item>
              {getFieldDecorator(formKeys.UREMEDIATE_DOMAIN, {
                initialValue: domain?.uremediate_domain,
                rules: [{ whitespace: true }]
              })(<Input placeholder={"OPTIONAL UREMEDIATE DOMAIN"} disabled={!form.getFieldValue(formKeys.UREMEDIATE)} />)}
            </Form.Item>
          </Col>
        </Row>}
        
      </Form>
    </StyledDomainForm>
  )
}

export default DomainForm
